<script>
    import Cabecera from "../Components/Layout/Cabecera.svelte";
</script>

<Cabecera />

<main>
    <slot />
</main>